import React, { useState } from "react";
import "./styles.scss";
import { VscCloseAll, VscExpandAll } from "react-icons/vsc";

const Collapsible = ({ children, label }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="collapsible-wrap">
      <button className="toggleBtn" onClick={() => setIsOpen(!isOpen)}>
        <span>{label.toUpperCase()}</span>
        <span>{isOpen ? <VscCloseAll size={25} /> : <VscExpandAll size={25} />}</span>
      </button>

      <div className={isOpen ? "show-content" : "content"}>{children}</div>
    </div>
  );
};

export default Collapsible;
